module.exports = __webpack_public_path__ + "static/img/cert3.fe0f6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert3.png
// module id = OETR
// module chunks = 51